<template>
  <div id="app">
    <router-view></router-view>
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld.vue";
import { APP_LINK_FLAG, APP_ID } from "./config/global.js";
export default {
  name: "app",
  components: {
    // HelloWorld
  },
  created() {},
  mounted() {
    try {
      window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "四通集团" });
      });
    } catch (error) {
      if (APP_LINK_FLAG == true) {
        let queryStr = window.location.href.split("?")[1];
        queryStr === undefined && (queryStr = "");
        window.location.href = `https://applink.feishu.cn/client/web_app/open?appId=${APP_ID}&path=${
          window.location.pathname
        }&${queryStr}`;
      }
    }
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  background: #f7f4f8;
  font-size: 14px;
  color: #505050;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
ol,
ul {
  list-style: none;
}
a {
  text-decoration: none;
  color: #333;
}
.seomain {
  height: 100%;
}
</style>
